import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-header-footer-bg text-gray-600 py-8">
    <div className="container mx-auto px-4">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <Link to="/" className="text-2xl font-bold text-gray-800 hover:text-red-600 transition-colors">
            FinanCalcs
          </Link>
        </div>
        <nav className="flex space-x-4">
          <Link to="/about" className="hover:text-red-600 transition-colors">About</Link>
          <Link to="/contact" className="hover:text-red-600 transition-colors">Contact Us</Link>
          <Link to="/privacy" className="hover:text-red-600 transition-colors">Privacy Policy</Link>
        </nav>
      </div>
      <div className="mt-8 pt-8 border-t border-gray-200 text-center">
        <p>&copy; {new Date().getFullYear()} FinanCalcs. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;